"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const http_status_1 = __importDefault(require("http-status"));
const pncieDomain = 'pncie.com';
const mobilitasDomain = 'mobilitasinsurance.com';
class PaymentCentralClient {
    constructor(baseUrl, oktaToken) {
        this.baseUrl = baseUrl;
        this.oktaToken = oktaToken;
        this.validateBaseUrl();
    }
    validateBaseUrl() {
        let protocol = null;
        let hostname = null;
        if (this.baseUrl) {
            const url = new URL(this.baseUrl);
            hostname = url.hostname;
            protocol = url.protocol;
        }
        if (protocol !== 'https:' ||
            !hostname ||
            (!hostname.endsWith(pncieDomain) && !hostname.endsWith(mobilitasDomain))) {
            throw new Error(`provided baseUrl must end with ${mobilitasDomain} or ${pncieDomain} and must begin with https`);
        }
    }
    async makeRequest(opts) {
        var _a, _b;
        if (opts.urlSuffix.length === 0 || !opts.urlSuffix.startsWith('/')) {
            return {
                success: false,
                errorCode: 'MALFORMED_URL_SUFFIX',
                errorMessage: 'provided url must begin with a forward slash'
            };
        }
        if ((_a = opts.data) === null || _a === void 0 ? void 0 : _a.correlationId) {
            opts.data.corellationId = (_b = opts.data) === null || _b === void 0 ? void 0 : _b.correlationId;
            delete opts.data.correlationId;
        }
        const url = `${this.baseUrl}${opts.urlSuffix}`;
        const headers = {
            Authorization: `Bearer ${this.oktaToken}`
        };
        try {
            const axiosResponse = await axios_1.default({
                data: opts.data,
                url,
                method: opts.method,
                headers
            });
            return { success: true, item: axiosResponse.data };
        }
        catch (err) {
            const errResponse = err.response ? err.response : null;
            if (errResponse === null) {
                console.error('request failed', {
                    request: { url, method: opts.method }
                });
                return {
                    success: false,
                    errorCode: 'AXIOS_CALL_FAILED',
                    errorMessage: err.toString()
                };
            }
            if (errResponse.status !== http_status_1.default.BAD_REQUEST) {
                console.error('request failed', {
                    request: { url, method: opts.method },
                    response: {
                        status: errResponse.status,
                        data: errResponse.data
                            ? JSON.stringify(errResponse.data)
                            : undefined
                    }
                });
                return {
                    success: false,
                    errorCode: 'AXIOS_CALL_FAILED',
                    errorMessage: err.toString()
                };
            }
            const res = errResponse.data;
            return {
                success: false,
                errorCode: 'BAD_REQUEST',
                errorMessage: res.error.errorMessage
            };
        }
    }
    async getEftToken(req) {
        return this.makeRequest({
            urlSuffix: '/paymentaccount/record',
            method: 'POST',
            data: req
        });
    }
    async getCreditCardToken(req) {
        return this.makeRequest({
            urlSuffix: '/paymentaccount/record',
            method: 'POST',
            data: req
        });
    }
}
exports.PaymentCentralClient = PaymentCentralClient;
//# sourceMappingURL=payment-central-client.js.map